import React, { FunctionComponent } from 'react'
import styles from './ObjectLineMobile.module.sass'
import { useRootDispatch, useRootSelector } from '../../../../../../utils/hooks'
import { objectSelector, parentsSelector } from '../../../../../../utils/selectors'
import { projectListActions } from '../../../../../../redux/pages/project-list'
import { push } from 'connected-react-router'
import { urlWithParams } from '../../../../../../http/utils'
import { ROUTES } from '../../../../../../http/routes'
import TaskMobile from '../../../ProjectPage/tasks/TaskMobile/TaskMobile'
import ObjectHeader from '../../../ProjectPage/ObjectHeader/ObjectHeader'
import { ID } from '../../../../../../types/UtilityTypes'

interface ObjectLineProps {
    objectId: ID,
}

const ObjectLineMobile: FunctionComponent<ObjectLineProps> = ({objectId}) => {
    const dispatch = useRootDispatch()
    const open = useRootSelector(state => state.pages.projectList.openObjects[objectId])
    const object = useRootSelector(objectSelector(objectId))
    const parents = useRootSelector(parentsSelector(objectId))
    const openTasks = useRootSelector(state => state.pages.projectList.openTasks)

    if (!object) {
        return null
    }

    return <>
        <ObjectHeader
            // className={styles.line}
            active={open}
            objectId={objectId}
            arrow={object.tasks_count === 0? 'none': undefined}
            markWidth={2}
            onArrowClick={() => {
                if (object.tasks_count > 0) {
                    dispatch(projectListActions.toggleObject(objectId))
                }
            }}
            onTextClick={() => dispatch(push(urlWithParams({
                objectId,
                projectId: object.project_id
            })(ROUTES.OBJECT)))}
        />
        <div className={styles.list}>
            {
                open && parents.map(parentId => <TaskMobile
                    key={parentId}
                    projectId={object?.project_id}
                    objectId={objectId}
                    parentId={parentId}
                    taskId={openTasks[parentId] ?? parentId}
                    onChange={taskId => dispatch(projectListActions.openTask({taskId, parentId}))}
                />)
            }
        </div>
    </>
}

export default ObjectLineMobile